export default "__VITE_ASSET__KBRDJvPg__"